import React from "react";
import { Container, PageHero } from "@/components/ui-blocks";
import Seo from "@/components/Seo";
import { COMPANY } from "@/data/mockData";
import { LegalBody, LegalSection } from "@/components/LegalBody";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="bg-[#FDFBF7]">
      <Seo
        title="Privacy Policy"
        description="How Ace Asia Productions collects, uses, and protects your personal data in accordance with Singapore's Personal Data Protection Act (PDPA)."
      />
      <PageHero
        testId="privacy-hero"
        overline="Legal"
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your personal data."
      />

      <Container>
        <LegalBody updated="July 2026">
          <LegalSection title="1. Introduction">
            <p>
              {COMPANY.name} (UEN {COMPANY.uen}) (&ldquo;we&rdquo;,
              &ldquo;us&rdquo;, &ldquo;our&rdquo;) is committed to protecting
              your privacy. This policy explains how we collect, use, disclose
              and safeguard your personal data when you visit
              {" "}<strong>aceasia.com.sg</strong> or place an order with us, in
              accordance with Singapore&apos;s Personal Data Protection Act 2012
              (&ldquo;PDPA&rdquo;).
            </p>
          </LegalSection>

          <LegalSection title="2. Information we collect">
            <p>When you use our website or place an order, we may collect:</p>
            <ul>
              <li><strong>Contact details</strong> — name, email address, phone number.</li>
              <li><strong>Delivery details</strong> — shipping address and order notes.</li>
              <li><strong>Order information</strong> — the items you purchase and your order history.</li>
              <li><strong>Enquiry information</strong> — any message you send us through the contact form.</li>
            </ul>
            <p>
              <strong>Payment information:</strong> card payments are processed
              securely by <strong>Stripe</strong>. We do not collect or store
              your full card details on our servers.
            </p>
          </LegalSection>

          <LegalSection title="3. How we use your information">
            <ul>
              <li>To process, fulfil and deliver your orders.</li>
              <li>To send order confirmations, payment and delivery updates by email.</li>
              <li>To respond to your enquiries and provide customer support.</li>
              <li>To maintain our records and improve our products and services.</li>
              <li>To comply with legal and regulatory obligations.</li>
            </ul>
          </LegalSection>

          <LegalSection title="4. Disclosure of your information">
            <p>
              We do not sell your personal data. We may share it only with
              trusted service providers who help us operate the website and
              fulfil orders — for example, our payment processor (Stripe),
              email/delivery providers, and hosting services — and only to the
              extent necessary to provide those services, or where required by
              law.
            </p>
          </LegalSection>

          <LegalSection title="5. Data protection & retention">
            <p>
              We take reasonable technical and organisational measures to protect
              your personal data against unauthorised access, loss or misuse. We
              retain personal data only for as long as necessary to fulfil the
              purposes described above or as required by law.
            </p>
          </LegalSection>

          <LegalSection title="6. Your rights">
            <p>
              Under the PDPA, you may request access to, or correction of, the
              personal data we hold about you, and you may withdraw consent to
              our use of your data. To make a request, contact us using the
              details below.
            </p>
          </LegalSection>

          <LegalSection title="7. Cookies">
            <p>
              Our website uses essential cookies and similar technologies to
              keep your shopping cart working and to remember your preferences.
              You can control cookies through your browser settings.
            </p>
          </LegalSection>

          <LegalSection title="8. Contact us">
            <p>
              If you have any questions about this Privacy Policy or your
              personal data, please contact us:
            </p>
            <ul>
              <li>{COMPANY.name}</li>
              <li>Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              <li>Phone: <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`}>{COMPANY.phone}</a></li>
            </ul>
          </LegalSection>
        </LegalBody>
      </Container>
    </div>
  );
}
